import { axiosGet } from '@/api/handlers';
import { getQueryClient } from '@/lib/react-query';
import {
  CorporatesModel,
  type CorporatesModelType,
} from '../_models/government-search';
import {
  type FetchGovernmentNumberParams,
  governmentSearchQueryKeyMap,
} from '../_utils/query-keys';

export const fetchGovernmentNumber = (
  params: FetchGovernmentNumberParams,
): Promise<CorporatesModelType[]> => {
  return getQueryClient().fetchQuery<CorporatesModelType[]>(
    governmentSearchQueryKeyMap.governmentNumber(params),
    async () => {
      const res = await axiosGet(
        '/api/government-api/corporate-by-number/',
        params,
      );
      return CorporatesModel.parse(res);
    },
  );
};
